import { usePdfData } from '@hcs/pdf/pdf-service';
import { ReportApiReports } from '@hcs/types';

export const useReport = <D extends ReportApiReports>() => {
  return usePdfData<D>();
};
